import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    head: {
        height: 28
    }
});

const Supplies = props => (
    <Table>
        <TableHead>
            <TableRow className={props.classes.head}>
                <TableCell>Supply</TableCell>
                <TableCell>Id</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {props.data.map(n => {
                return (
                    <TableRow key={n.id}>
                        <TableCell>{n.type}</TableCell>
                        <TableCell>{n.number}</TableCell>
                    </TableRow>
                );
            })}
        </TableBody>
    </Table>
);

Supplies.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Supplies);


// WEBPACK FOOTER //
// ./src/modules/clients/src/components/Supplies.js